import React from "react";
import { useAuth } from "@/contexts/AuthContext";
import { Eye } from "lucide-react";

/** Hook: true, wenn der eingeloggte Benutzer nur lesen darf (Rolle 'guest'). */
export function useReadOnly() {
    const { user } = useAuth();
    return user?.role === "guest";
}

/** Banner, den man am Seitenanfang einbinden kann, damit Gäste erkennen,
 * dass sie sich in einer Nur-Lese-Ansicht befinden. */
export default function ReadOnlyBanner() {
    const readOnly = useReadOnly();
    if (!readOnly) return null;
    return (
        <div
            className="rounded-md border border-yellow-500/40 bg-yellow-500/10 px-4 py-2 text-xs text-yellow-200 flex items-center gap-2"
            data-testid="readonly-banner"
        >
            <Eye className="h-3.5 w-3.5" />
            <span>
                <strong>Nur-Lese-Modus (Gast).</strong> Sie können Daten einsehen und Berichte
                herunterladen, aber keine Änderungen vornehmen.
            </span>
        </div>
    );
}
